import {
  string as yupString,
} from 'yup';

import TextAreaFormik from '../../forms/textarea/textareaFormik.component';
import SelectFormik from '../../forms/select/sdkSelectFormik.component';
import { required } from '../../forms/validators';

import { REQUEST_TYPES } from './constants';

const schema = [
  {
    name: 'typeOfRequest',
    component: SelectFormik,
    meta: { label: 'Type of Request', options: REQUEST_TYPES },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'requestDescription',
    component: TextAreaFormik,
    meta: { label: 'Type', optionsKey: 'connectionTypeOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true, resize: 'vertical' },
  },
];

export default schema;
